















import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'start',
})
export default class Start extends Vue { }
